<template>
  <div>
    <b-alert
      :show="!!errorHandlingMessage"
      variant="danger"
      dismissible
      >{{ errorHandlingMessage }}</b-alert
    >
    <b-tabs
      v-model="tabIndex"
      no-nav-style
      :vertical="useVerticalFormTabs"
      :nav-wrapper-class="[useVerticalFormTabs && formCount > 1 ? 'col-4' : '']"
      :nav-class="['spl-task-form-nav-pills', 'shadow-inset', 'mb-3', formCount < 2 ? 'd-none' : '']"
      @activate-tab="handleActivateTab"
    >
      <template
        v-if="useVerticalFormTabs && formsMenuTitle"
        #tabs-start
      >
        <h5
          v-if="formsMenuTitle"
          class="font-weight-bold my-2 ml-2 text-primary-darker"
        >
          {{ formsMenuTitle }}
        </h5>
      </template>
      <b-tab
        v-for="form in localForms"
        :key="form.key"
      >
        <!-- no lazy, so they all load validation status -->
        <template #title>
          <span>{{ form.title }}</span>
          <div
            v-if="showValidation && !form.hide_validation"
            class="ml-2 d-inline"
          >
            <!-- <transition name="fade-faster" mode="out-in"> -->
            <b-icon
              v-if="form.isValid"
              key="isValid"
              icon="check-circle-fill"
              variant="success"
              font-scale="1"
            ></b-icon>
            <b-icon
              v-else-if="form.isValid === false"
              key="notValid"
              icon="x-circle-fill"
              variant="danger"
              font-scale="1"
            ></b-icon>
            <b-icon
              v-else-if="form.isValid === null"
              key="unknownValid"
              icon="circle-fill"
              variant="secondary-lighter"
              font-scale="1"
            ></b-icon>
            <!-- </transition> -->
          </div>
        </template>
        <FlowNodeFormSingle
          :flowObjectClass="flowObjectClass"
          :flowObjectId="flowObjectId"
          :flowSubtype="flowSubtype"
          :nodeKey="nodeKey"
          :formKey="form.key"
          ref="taskFormSingle"
          class=""
          @ready="handleFormReady"
          @submitted="handleFormSaved(form.key, $event)"
          @busy="handleFormBusy(form.key, $event)"
          @is-valid="handleFormIsValid(form.key, $event)"
        ></FlowNodeFormSingle>
        <!-- :key="reloadHash" -->
        <hr />
        <!-- <div class="mt-3 d-flex justify-content-between align-items-end gap-2">
                    <div class="d-flex justify-content-start align-items-end gap-4"> -->
        <div class="row">
          <div class="col-12 col-lg-7 col-xl-6">
            <div class="d-flex justify-content-center justify-content-lg-start align-items-end gap-4">
              <b-button
                v-if="hasMultipleForms"
                variant="sharp-primary"
                size="lg"
                :disabled="!hasPrevious"
                class="d-flex gap-2 align-items-center"
                @click="handlePreviousClick"
              >
                <div class="">&larr;</div>
                <div class="font-size-80">Previous</div>
                <!-- Previous Page -->
              </b-button>
              <b-button
                v-if="hasMultipleForms"
                variant="sharp-primary"
                size="lg"
                :disabled="!hasNext"
                class="d-flex gap-2 align-items-center"
                @click="handleNextClick"
              >
                <div class="font-size-80">Next</div>
                <!-- Next Page -->
                <div class="">&rarr;</div>
              </b-button>
            </div>
          </div>
          <div class="col-12 col-lg-5 col-xl-6 mt-3 mt-lg-0">
            <div class="d-flex gap-4 align-items-center justify-content-center justify-content-lg-end">
              <!-- <div style="">
                                <b-spinner v-if="isLoading" small class=""></b-spinner>
                                <b-badge v-else-if="savedShowing" variant="success" class="text-uppercase">Saved</b-badge>
                            </div> -->
              <b-button
                v-if="completeTaskButtonParams.visible"
                :key="completeTaskButtonParams.key"
                :variant="completeTaskButtonParams.variant"
                class=""
                size="lg"
                :disabled="completeTaskButtonParams.disabled"
                @click="handleCompleteTaskClick"
              >
                {{ completeTaskButtonParams.text }}
              </b-button>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import { errorHandling } from '../../js/custom-vue-mixins';
  import FlowNodeContentMixin from './FlowNodeContentMixin';
  import FlowNodeFormSingle from './FlowNodeFormSingle.vue';
  import isNumber from 'lodash/isNumber';

  export default {
    name: 'FlowNodeForms',
    components: {
      FlowNodeFormSingle,
    },
    mixins: [errorHandling, FlowNodeContentMixin],
    props: {
      // specified more props in mixin
      // flowObjectClass / flowObjectSubtype - so we can pass down to children
      /* flowObjectId: {
            type: String,
            required: true,
        },
        flowSubtype: {
            type: String,
            default: null,
        },
        nodeKey: {
            type: String,
            required: true,
        },
        nodeContext: {  // node-level context, with info/methods on calling transitions
            type: Object,
            required: true,  
        },
        nodeData: {
            type: Object,
            required: false, // we have it... but do we actually NEED it?
        }, */
      /* forms: {  // we can get from nodeData.forms instead!
            type: Array,
            required: false,  // not required if not started yet
        }, */
    },
    data: function () {
      return {
        errorMsg: 'Error',
        error: false,
        loading: false,
        tabIndex: 0, // current tab index managed by v-model -- be careful using this during tabChanges!
        registry: {}, // registry of forms, and their validation status -- this is what we actually iterate over
        localForms: [], // Object.values(this.registry) --- set when we update things from single forms - because computed is not reactive for nested stuff
        submitTriggerName: 'submit_form', // make sure this matches backend!
        // also need navigation controls from one to the other, overall validation status, etc.
        allFormsValid: false, // set when you update localForms
        anyFormsBusy: false, // set when we update localForms
        reloadHash: 'willchange', // update this each time you need to reload, just as a unique key -- not used anymore... using separate tabs
      };
    },
    watch: {
      tabIndex: {
        // EXPERIMENTAL: we will reload the form anytime tab index changes  (not currently used)
        handler: function () {
          this.reloadHash = new Date().toISOString();
        },
      },
    },
    computed: {
      // localForms() {  // don't do a computed... nested stuff isn't reactive... set it explicitly on updates
      //     // we iterate over the registry values -- so it has our extra stuff added (isValid, index)
      //     return Object.values(this.registry);
      // },
      // we have MANY computed from the mixin:  loadingNode, hasNodeDetail, flowContext, etc.
      formCount() {
        return this.nodeData?.forms?.length ?? 0;
      },
      hasNext() {
        return this.formCount - this.tabIndex > 1;
      },
      hasPrevious() {
        return this.tabIndex > 0;
      },
      hasMultipleForms() {
        return this.formCount > 1;
      },
      currentTabKey() {
        // computed from tabIndex (v-model of b-tabs) -- be careful using this during tab changes!
        return this.getFormKeyFromIndex(this.tabIndex);
      },
      useVerticalFormTabs() {
        /// for now we hard-code this based on flow object class / node key -- change this!
        // return this.flowObjectClass === 'PpapRun' && this.nodeKey === 'supplier_task';
        return this.nodeData?.form_config?.forms_layout === 'vertical_tabs';
      },
      formsMenuTitle() {
        return this.nodeData?.form_config?.forms_menu_title ?? ''; // don't even show the div if empty
      },
      showValidation() {
        // only show validation if this is currently active and current user is assignee
        // show/hide validation for specific forms can be set with hide_validation on each form
        return this.isActive && this.isAssignee;
      },
      submitTriggerAvailable() {
        return !!this.nodeContext.nodeTriggers && Array.isArray(this.nodeContext.nodeTriggers) && this.nodeContext.nodeTriggers.includes(this.submitTriggerName);
      },
      currentSubmitTransition() {
        // we have multiple submit transitions (FormSubmitTransitionDefinition on backend)
        // they have different available 'source' states -- so we SHOULD have either one or none available at any given time...
        // we'll return the current active one here... but in case there are multiple (should not be) we just return the first one here
        const allNodeTransitions = this.nodeContext?.nodeTransitions ?? [];
        const submitTransitions = allNodeTransitions.filter((nt) => nt.trigger === this.submitTriggerName);
        return submitTransitions?.length ? submitTransitions[0] : null;
      },
      completeTaskButtonParams() {
        // return object with stuff for the complete task button
        // TODO - allow setting some things on backend... like button text in various states?
        // put them in the new form_config object somehow
        const submitDisabled = !this.allFormsValid || this.anyFormsBusy; // TODO - also disable it when you start tracking if any forms have unsaved changes?
        const canSubmitParams = {
          visible: true, // show/hide entirely
          key: 'canSubmit', // key just for nice v-if behavior
          variant: submitDisabled ? 'light-success' : 'success',
          //text: this.nodeType === 'update_form' ? 'Done' : 'Complete Task',
          text: this.currentSubmitTransition?.label ?? 'Submit', // won't have it if submit is not available
          disabled: submitDisabled,
        };
        const isWaitingParams = {
          visible: true,
          key: 'isWaiting',
          variant: 'bare-secondary',
          text: 'Task Waiting',
          disabled: true,
        };
        const isCompletedParams = Object.assign({}, isWaitingParams, { text: 'Task Completed', key: 'isCompleted' });
        if (this.submitTriggerAvailable) {
          return canSubmitParams;
        } else if (this.isCompleted) {
          return isCompletedParams;
        } else if (this.isWaiting) {
          return isWaitingParams;
        }
        return {
          // defaults if nothing else is true
          visible: false,
          key: 'hideButton',
        }; // something else?  just hide it for now
      },
    },
    created() {
      const formsFromProp = this.nodeData?.forms; // we were passing in 'forms' as a prop before... but its in nodeData, so use that -- promotes consistent interface for all nodes/tasks
      formsFromProp.forEach((f, idx) => {
        this.registerForm({ form: f, index: idx });
      }); // or do this when each one reports some 'ready' event?
      //this.localForms = Object.values(this.registry);
      this.updateLocalForms();
    },
    mounted() {
      //console.log(`MOUNTED FlowNodeForms for nodeKey ${this.nodeKey} - dumping nodeData:`, this.nodeData);
    },
    methods: {
      /// OVERRIDE FROM MIXIN - this is called from parent before any transition
      async beforeCallTransition({ transition, data }) {
        // CALLED FROM PARENT - FlowNode
        // after the user clicks 'confirm' when callingn a transtion, but before the actual API call is made
        // RETURNS: should always return a promise that resolves to boolean - True if OK to proceed, false if not
        // NOTE - this is called on ANY transition... we must check if its the 'submit_form' transition, otherwise ignore it
        // OVERRIDE THIS ON COMPONENTS THAT USE THIS MIXIN - but make sure the signature/return structure are SAME
        // params passed in are the transition object ('transition') and any payload data that will be sent in the API call ('data')
        // you can get the trigger name to check if you care about the transition from 'transition.trigger'
        // ONE PLACE TO USE THIS -- in task forms -- to trigger individual forms (form pages) to submit themselves if save_behavior is 'submit'
        // you don't want to call that before user clicks "confirm" to submit
        // but other places may not need this -- just return Promise.resolve(true) for those and no need to override where this is used then

        const triggerBeingCalled = transition.trigger;
        console.log(`in beforeCallTransition on ${this.$options.name} - nodeKey ${this.nodeKey}: trigger is ${triggerBeingCalled} - data is ${JSON.stringify(data)}`);

        if (triggerBeingCalled === this.submitTriggerName) {
          // we call .beforeNodeSubmit() on each form component -- they return a Promise that resolves to boolean - true if can proceed, false if not
          // if any of them have save_behavior of 'submit' they will save themselves during that... so if you have many forms like that, it could be a bunch of requests
          // so it may make sense to call each of them sequentially, rather than Promise.all() -- otherwise you may have race condition issues in backend
          const formComps = this.$refs['taskFormSingle']; // Array of them, if any
          let canProceed = false;
          if (formComps) {
            // for now just do a Promise.all() -- but maybe change later if you have many 'submit' save_behavior
            const formsOkArray = await Promise.all(
              formComps.map(async (singleFormComp) => {
                return await singleFormComp.beforeNodeSubmit();
              }),
            );
            /* const formsOkArray = Promise.all(formComps.map((singleFormComp) => {
                        return singleFormComp.beforeNodeSubmit(); 
                    })); */
            canProceed = formsOkArray.every((ok) => !!ok);
          } else {
            canProceed = true; // if no forms... then whatever, keep going
          }
          if (!canProceed) {
            console.log('Some forms are incomplete or invalid or otherwise had submit issues');
            return false;
          } else {
            console.log('at the end of beforeCallTransition - canProceed is true so we will continue');
            return true;
          }
        }
        // if not our submit trigger, just return true to proceed
        return true;
      },
      // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
      registerForm({ form, index }) {
        console.log(`registering formKey ${form.key} at index ${index}`);
        // we just clone 'form', and add things to track validation, index, etc.
        // form objects just have { key, title, instructions, save_behavior, save_button_text, hide_validation } - maybe other things you add later?
        // we key them by their key (duh) - keep in an object - maps are harder for reactivity
        // TODO - also need to track 'hasChanges' or similar for each form... to know if any have unsaved data
        const formReg = {
          // you could just do ...form -- but we'll be explicit since we count on certain keys in stuff here
          key: form.key,
          title: form.title, // for nav, etc.
          instructions: form.instructions,
          ...form, // so we automatically include any new attributes we add to form spec on backend
          isValid: null, // start null - then set true/false when you report @is-valid event from each form
          isBusy: null, // set to the value from @busy events passed by single forms
          index: index,
          component: null, // the actual FormulateForm component -- will come in @ready event of single form
        };
        this.registry[formReg.key] = formReg;
      },
      getFormKeyFromIndex(index) {
        const formObjInRegistry = Object.values(this.registry).find((f) => f.index === index);
        return formObjInRegistry ? formObjInRegistry.key : null;
      },
      getSingleForm({ index, key }) {
        // return the FlowNodeFormSingle COMPONENT INSTANCE for given index OR key
        // must get from ref, but ref is array, so need to use index/key - or use registry instead???
        // returns null if not found for some reason
        // TODO - USE REGISTRY FOR ALL THINGS
        const singleForms = this.$refs.taskFormSingle; // Array!
        // NOTE: be very careful when using index from tabIndex!  during tab changes. this.tabIndex might get set before we have validated that we should actually change tabs...
        if (isNumber(index)) {
          const singleForm = !!singleForms && Array.isArray(singleForms) ? singleForms[index] : null;
          return singleForm;
        } else if (key) {
          const singleFormReg = this.registry[key];
          return singleFormReg ? singleFormReg.component : null;
        }
      },
      isSingleFormValid(formKey) {
        // just return the isValid value from registry for this form key
        // that gets updated from the @is-valid event from each form, which is based on the validation status of that form
        const formReg = this.registry[formKey];
        return formReg ? formReg.isValid : null;
      },
      handleNextClick() {
        // this updates the v-model on b-tabs, which THEN fires the @activate-tab event, which we use to trigger the refresh of the form page, etc.
        if (this.hasNext) {
          this.tabIndex++;
          console.log('handleNextClick - new tab index:', this.tabIndex);
          // TODO - call something that validates then changes tab if valid (something in between handleActivateTab and changeTab)
        }
      },
      handlePreviousClick() {
        // this updates the v-model on b-tabs, which THEN fires the @activate-tab event, which we use to trigger the refresh of the form page, etc.
        if (this.hasPrevious) {
          this.tabIndex--;
          console.log('handlePreviousClick - new tab index:', this.tabIndex);
        }
      },
      handleActivateTab(newTabIndex, prevTabIndex, bvEvent) {
        // NOTE:  THIS MUST BE SYNC IF WE WILL USE IT TO preventDefault / cancel tab change
        // from @activate-tab event on b-tabs - should not get called on initial tab load (good)
        // this is emitted "just BEFORE a tab is shown/activated" -- happens BEFORE @input event
        // we use this to refresh the form page (new tab) when a page is clicked, so it has the latest data from any other pages it depends on
        // this gets called any way the tab gets changed... so safer to do things here
        // this event is also cancellable, if you need that -- but if you cancel here, then you CANNOT change tab manually.... that just triggers this again
        console.log('handleActivateTab', newTabIndex, prevTabIndex, bvEvent);
        // const newTabKey = this.getFormKeyFromIndex(newTabIndex);
        
        // we ONLY need to do this when editing... not if read-only...
        // if the entire node is not editable, then we bail out early... let the tab get changed
        // if the previous form/tab we're changing away from is not editable, then we don't do any of the prevFormComp checks... 
        // but we still refresh the new form/tab as normal, if overall node isEditable (because maybe it depends on other forms, etc.)
        
        const prevFormComp = this.getSingleForm({ index: prevTabIndex });
        const prevFormCompIsReadOnly = prevFormComp ? prevFormComp.isReadOnly : true; // if we can't find the form component for some reason, we will just assume it's read-only, to be safe
        if (prevFormComp && !prevFormCompIsReadOnly) {
          // NOTE as of April 7 2026 -- due to the mess in FlowNodeFormSingle, we are not sure we will RELIABLY have a return value (that is useful) from beforeNavigateAway()
          //     so we only call that (sync) when we know it is needed to possibly save the changes...
          // BUT, we can at least check if there are unsaved changes in the form, and if so, show confirmation before navigating away
          // some of our methods in here use index of form, some use key.... that's a f'ing mess... clean it up later...
          const prevFormKey = this.getFormKeyFromIndex(prevTabIndex);
          const prevFormHasChanges = prevFormComp.checkDataChanged(); // this re-runs the checks (sync) and updates .hasChanges and returns it... safer than just checking .hasChanges
          if (!prevFormKey) {
            console.error('Could not find form key for previous tab index -- should not happen, means there is a problem with your local registry!', prevTabIndex);
          }
          const prevFormRegObj = prevFormKey ? this.registry[prevFormKey] : null;  // we SHOULD always have prevFormKey... this is just super defensive...
          const prevFormTitle = prevFormRegObj ? prevFormRegObj.title : 'Current Form';
          const prevFormIsValid = prevFormKey ? this.isSingleFormValid(prevFormKey) : prevFormComp.localIsValid; // we only fall back to this in case our registry stuff here is not working as expected... (should be cleaned up)
          
          // handle the various cases we have here...
          // at the end, we will call prevFormComp.beforeNavigateAway() which will actually DO all the things like saving unsaved changes (if form is valid), etc.
          // but that all works ASYNC, and this must be called sync to actually prevent the tab change if needed... 
          // so we are separately checking if there are changes and if valid, then showing confirmation just based on those 
          if (prevFormHasChanges && !prevFormIsValid) {
            // if there are changes, and the form is not valid, we want to show a confirmation before navigating away -- because they will lose their changes, and they won't be valid if they come back
            // if there are changes but the form is valid, we don't need to show a confirmation -- they can just navigate away and come back and their form will still be valid
            // if there are no changes, we don't need to show a confirmation -- they can just navigate away and come back and their form will still be in the same state
            console.warn('Form has unsaved changes and is currently invalid -- showing browser confirmation before navigating away');
            // console.warn('prevFormHasChanges', prevFormHasChanges, 'prevFormIsValid', prevFormIsValid, 'registryObject.isValid', prevFormRegObj?.isValid, 'registryObject.isBusy', prevFormRegObj?.isBusy);
            const confirmLeave = window.confirm(`There are unsaved changes in ${prevFormTitle}, but the form is not complete.  If you proceed, you will lose those changes.  Click OK to proceed and lose the unsaved changes.  Click Cancel to stay on the ${prevFormTitle} form.`);
            if (!confirmLeave) {
              // user says NO to nav away...
              console.log('User cancelled tab change after confirmation about unsaved changes and invalid form');
              bvEvent.preventDefault(); // stop tab change
              return; // return early - NO TAB CHANGE
            } else {
              // if here, the user confirmed to leave, not save their unsaved changes
              // and form is invalid, so any save call would not actually succeed... so we won't even try
              // BUT, we should tell the previous form to refresh itself to make sure it is showing the correct validation status and data after the user cancels the tab change 
              prevFormComp.refresh(); // just refresh the form we are currently on, to make sure it is showing the correct validation status and data after the user cancels the tab change
              // if we later allow saving invalid forms (partial saves?) then this would have to be updated
              // user says OK to nav away... we will NOT save any unsaved changes, but we will still refresh the new form
              console.log('User confirmed tab change despite unsaved changes and invalid form - proceeding with tab change');
            }
          } else if (prevFormHasChanges && prevFormIsValid) {
            // if there are changes, but the form is valid, we want to show a confirmation before navigating away -- because they will lose their changes, but at least the form will still be valid when they come back
            // we will do nothing here, just let beforeNavigateAway() handle the saving of changes at the end of this function
            console.log('Form has unsaved changes but is currently valid -- changes will be saved quietly');
            prevFormComp.beforeNavigateAway().then((beforeNavAwayResult) => {
              console.log('Checked current form beforeNavigateAway -- result:', beforeNavAwayResult);
              this.refreshForm(newTabIndex);  // if we have a previous form, we must make sure the save on that is complete BEFORE we refresh the next one (because of possible conditional logic between them, etc.)
            });
            return;  // return early, that's all we need to do here
          } else if (!prevFormHasChanges && !prevFormIsValid) {
            console.log('Previous form is invalid, but has no unsaved changes, so nothing to confirm with user');
            // just let the new tab get refreshed...
          } else {
            console.log('Form has no unsaved changes, so no confirmation needed to navigate away');
            // just let the new tab get refreshed...
          }
          // if we made it this far without returning early, that means we are OK to navigate to new tab, and we should refresh the new tab
          // letting it happen outside this if block... safe to do in all those cases
        } 
        if (this.isEditable) { // NOTE: this.isEditable is from the mixin... it relates to the overall NODE editability (not just a single form)
          this.refreshForm(newTabIndex); // await this??? it is async... but just fire and forget... change tabs and let new one load after change
        }
        
      },
      refreshForm(formIndex) {
        // pass in the index of the form to call .refresh() on
        // JUST GET IT FROM INDEX OF refs -- all the task form singles will be in a single ref, as an array
        const singleForms = this.$refs.taskFormSingle; // Array!
        const singleForm = !!singleForms && Array.isArray(singleForms) ? singleForms[formIndex] : null;
        if (singleForm) {
          //console.log('will call refresh on this singleForm', singleForm);
          singleForm.refresh(); // call refresh method of the component
        } else {
          //console.log('Could not find the singleForm to call refresh on!');
        }
      },
      handleFormReady({ component, key }) {
        console.log(`FlowNodeForms on ${key}: handleFormReady`);
        const formReg = this.registry[key];
        formReg.component = component;
        this.$set(this.registry, key, formReg);
        this.updateLocalForms();
      },
      handleFormSaved(...payload) {
        const [formKey, submitData] = payload;
        console.log(`FlowNodeForms on ${formKey}: handleFormSaved`, submitData);
        this.emitUpdated(submitData); // using our common emit method on the MIXIN
        //this.$emit('submitted', submitData);  // relay something to parent to let them know we updated some things
      },
      handleFormBusy(...payload) {
        const [formKey, isBusy] = payload;
        console.log(`FlowNodeForms on ${formKey}: handleFormBusy - isBusy: ${isBusy}`);
        const formReg = this.registry[formKey];
        formReg.isBusy = isBusy;
        this.$set(this.registry, formKey, formReg);
        this.updateLocalForms(); // for some reason the watch on registry is not working
      },
      handleFormIsValid(...payload) {
        const [formKey, isValid] = payload;
        console.log(`FlowNodeForms on ${formKey}: handleFormIsValid - isValid: ${isValid}`);
        // gotta use $set so its reactive - get current object, mutate it, set it back on instance with $set
        // TODO (maybe) -- don't set the entire object in registry again... just call $set on the specific nested key that changed...?
        const formReg = this.registry[formKey];
        formReg.isValid = isValid;
        this.$set(this.registry, formKey, formReg);
        this.updateLocalForms(); // for some reason the watch on registry is not working
      },
      updateLocalForms() {
        // call this explicitly from watch and any other places
        this.localForms = Object.values(this.registry);
        //console.log('updateLocalForms', this.localForms, this.localForms.map(lf => lf.isValid));
        // for allFormsValid - if any have hide_validation=True, we ignore them
        this.allFormsValid = this.localForms.every((lf) => lf.isValid || lf.hide_validation);
        this.anyFormsBusy = this.localForms.some((lf) => lf.isBusy);
      },
      async handleCompleteTaskClick() {
        // FIRST -- call the beforeNavigateAway() hook on the CURRENTLY VISIBLE form -- maybe ALL of them???
        // non-visible ones *should* already be OK... unless some data on current form makes some other form invalid?
        const currentSingleForm = this.getSingleForm({ index: this.tabIndex });
        if (currentSingleForm) {
          const canProceed = await currentSingleForm.beforeNavigateAway(); // this will submit if there are changes, and if its possible
          if (!canProceed) {
            // TODO - show some invalid message / toast / modal?
            //console.log('Checked current form beforeNavigateAway -- NOT OK to proceed - cancelling task completion!');
            return;
          } else {
            //console.log(`Checked current form beforeNavigateAway -- OK to proceed -- continuing with task submission`);
            // just proceed with the rest of method....
          }
        }
        // START the transition of 'submit_form' -- it will show the confirm modal first
        // use the .startTransition() method provided by the MIXIN
        // for forms with save_behavior = 'submit' - we don't tell them to submit here... but once user clicks on 'confirm' in the modal
        //console.log('complete task');
        this.startTransition(this.submitTriggerName); // opens modal to confirm - FROM MIXIN
      },
    },
  };
</script>

<style lang="scss">
  .spl-task-form-nav {
    border-bottom: 1px solid var(--gray-300);
    .nav-item {
      .nav-link {
        border-bottom: 4px solid transparent;
        color: var(--dark);
        transition: 0.15s all;
        font-weight: 600;
        opacity: 0.6;
        .b-icon.bi {
          font-size: 100%; // normally its 125% in navs
        }
        //background-color: transparent;
        &:hover {
          //color: #000;
          border-bottom-color: var(--gray-200);
          opacity: 0.9;
        }
        &.active {
          border-bottom-color: var(--primary);
          //color: #000;
          opacity: 1;
          //background-color: var(--primary-100);
          &:hover {
            border-bottom-color: var(--primary-600);
          }
        }
      }
    }
  }

  .spl-task-form-nav-pills {
    //border-bottom: 1px solid var(--gray-300);
    background-color: var(--gray-200);
    border-radius: 0.6rem;
    padding: 0.3rem;
    gap: 0.3rem;
    // we have shadow-inset set above using utility class
    .nav-item {
      .nav-link {
        //border-bottom: 4px solid transparent;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
        border: 1px solid var(--gray-300);
        border-radius: 0.4rem;
        color: #000; // var(--dark);
        transition: 0.15s all;
        font-weight: 600;
        opacity: 0.7;
        .b-icon.bi {
          font-size: 100%; // normally its 125% in navs
        }
        //background-color: transparent;
        &:hover {
          //color: #000;
          //border-bottom-color: var(--gray-200);
          //background-color: var(--gray-150);
          opacity: 0.95;
          border-color: var(--gray-500);
        }
        &.active {
          //border-bottom-color: var(--primary);
          background-color: var(--primary-50);
          border-color: var(--primary-300);
          color: #000;
          opacity: 1;
          //background-color: var(--primary-100);
          &:hover {
            //border-bottom-color: var(--primary-600);
            background-color: var(--primary-100);
            border-color: var(--primary-400);
          }
        }
      }
    }
  }
</style>
